var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H10C10.5304 16 11.0391 15.7893 11.4142 15.4142C11.7893 15.0391 12 14.5304 12 14V5.414C11.9997 5.01631 11.8414 4.63503 11.56 4.354L7.646 0.439C7.3648 0.157982 6.98355 8.48813e-05 6.586 0H2ZM1 2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H6V4.5C6 4.89782 6.15804 5.27936 6.43934 5.56066C6.72064 5.84196 7.10218 6 7.5 6H11V14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15H2C1.73478 15 1.48043 14.8946 1.29289 14.7071C1.10536 14.5196 1 14.2652 1 14V2ZM10.793 5H7.5C7.36739 5 7.24021 4.94732 7.14645 4.85355C7.05268 4.75979 7 4.63261 7 4.5V1.207L10.793 5Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84604 11.5L6.37177 13.8536C6.16648 14.0488 5.83365 14.0488 5.62837 13.8536L3.15402 11.5C2.94874 11.3047 2.94874 10.9882 3.15402 10.7929C3.35931 10.5976 3.69214 10.5976 3.89742 10.7929L5.47441 12.2929L5.47441 7.5C5.47441 7.22386 5.70975 7 6.00007 7C6.29038 7 6.52573 7.22386 6.52573 7.5L6.52573 12.2929L8.10264 10.7929C8.30792 10.5976 8.64075 10.5976 8.84604 10.7929C9.05132 10.9882 9.05132 11.3047 8.84604 11.5Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadWhite);
export default __webpack_public_path__ + "static/media/file-upload-white.d322bd1f7517ec47b4832c0ac6f83f8b.svg";
export { ForwardRef as ReactComponent };